
export class CommandDetails {
	public baseUrl = "";
	public endpoint = "";
	public payload = {};
	public headers = {};
}